import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { RoadmapDeliverableWrapperLayout } from '../Wrapper/RoadmapDeliverableWrapperLayout';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  useBoneBackgroundColor();

  const anySelected = !!resource.attr('selectedAction');

  if (!resource) {
    return null;
  }

  const skipRel = resource.withRelationship(fr.relationships.skip.name, (rel) => rel, () => null);

  return (
    <RoadmapDeliverableWrapperLayout disabled={!anySelected} pushNavToBottom={false} clickableTextRel={skipRel}>
      <FDStack direction={'column'} alignItems={'center'} paddingY={4} spacing={4} width={'100%'} maxWidth={600}>
        <FDStack direction="column" spacing={2} padding={2} width={'100%'}>
          <MetaControlField attr={'selectedAction'} />
        </FDStack>
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default Layout;
